import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LoaderCstm from "../../../components/Loader";
import { verifyOTP } from "../../../lib/store/actions";
import styles from "../../../components/Layout/Authlayout/Authe.module.scss";
import { useGameContext } from "../../../context/GameContext";

const Verify = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const email = location.state?.email || "";
  const { loading } = useSelector(({ Auth }) => Auth);
  const { setGame, setGameStart, setGameLoading } = useGameContext();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);

  const activeGameDetail = (userData) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (
          (userData?._id && !userData?.currentGame?._id) ||
          !userData?._id ||
          !userData?.currentGame?._id
        ) {
          setTimeout(() => {
            setLoader(false);
            setGameLoading(false);
            resolve();
          }, 2000);
          return;
        }

        setLoader(true);
        let updatedData = {
          ...userData?.currentGame,
          gameData: [],
          lineData: [],
        };
        updatedData = {
          ...updatedData,
          gameData: userData?.currentGame?.gameData,
          lineData: userData?.currentGame?.lineData,
          winnings: updatedData?.winnings?.length
            ? [...updatedData.winnings]
            : [],
        };

        setGame({
          ...updatedData,
          gameData: updatedData?.gameData?.reverse(),
          lineData: updatedData?.lineData?.reverse(),
        });

        setTimeout(() => {
          setLoader(false);
          setGameLoading(false);
          resolve(updatedData);
          setGameStart(true);
        }, 1000);
      } catch (err) {
        setLoader(false);
        setGameLoading(false);
        reject(err);
      }
    });
  };

  const onVerify = async () => {
    setError(null);

    if (!otp.trim()) {
      setError("Please enter the OTP.");
      return;
    }
    setLoader(true);
    dispatch(
      verifyOTP({
        data: { otp, email },
        callBack: async (err, res) => {
          if (parseInt(err?.status_code) === 406) {
            setLoader(false);
            navigate("/maintenance");
            return;
          }
          if (err) {
            setError(err.message || "Failed to verify OTP.");
            setLoader(false);
            return;
          } else {
            await activeGameDetail(res);
            setTimeout(() => {
              setLoader(false);
              navigate("/game");
            }, 3000);
          }
        },
      }),
    );
  };

  return (
    <>
      {loader || loading ? (
        <div className="d-flex justify-content-center my-3">
          <LoaderCstm />
        </div>
      ) : (
        <div className="formBody">
          <Form>
            <div className="py-2">
              <label
                htmlFor="email"
                className="form-label m-0 text-white w-100 text-start"
              >
                Enter Email
              </label>
              <input
                id="email"
                type="email"
                placeholder="Email"
                className="form-control"
                value={email}
                disabled
              />
            </div>

            <div className="py-2">
              <label
                htmlFor="otp"
                className="form-label m-0 text-white w-100 text-start"
              >
                Enter OTP
              </label>
              <input
                id="otp"
                type="text"
                placeholder="Enter OTP"
                className="form-control"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                disabled={loading}
              />
            </div>

            {error && <div className="text-danger py-2">{error}</div>}

            <div className="py-2">
              <Button
                style={{ maxWidth: 250 }}
                className={`${styles.telegramBtn} mx-auto rounded-pill w-100 d-flex px-4 align-items-center justify-content-center mt-2`}
                onClick={onVerify}
                disabled={loading}
              >
                Verify
              </Button>
            </div>
          </Form>
        </div>
      )}
    </>
  );
};

export default Verify;
